import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import SizeMixin from "../../mixins/size.js";
import TagMixin from "../../mixins/tag.js";
import ListenersMixin from "../../mixins/listeners.js";
import { slot, mergeSlot } from "../../utils/slot.js";
export default Vue.extend({
  name: 'QIcon',
  mixins: [ListenersMixin, SizeMixin, TagMixin],
  props: {
    tag: {
      default: 'i'
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  computed: {
    classes: function classes() {
      // "notranslate" class is for Google Translate
      // to avoid tampering with Material Icons ligature font
      return 'q-icon notranslate' + (this.left === true ? ' on-left' : '') + (this.right === true ? ' on-right' : '') + (this.color !== void 0 ? " text-".concat(this.color) : '');
    },
    type: function type() {
      var _this = this;

      var cls;
      var icon = this.name;

      if (!icon) {
        return {
          none: true,
          cls: this.classes
        };
      }

      if (this.$q.iconMapFn !== void 0) {
        var res = this.$q.iconMapFn(icon);

        if (res !== void 0) {
          if (res.icon !== void 0) {
            icon = res.icon;
          } else {
            return {
              cls: res.cls + ' ' + this.classes,
              content: res.content !== void 0 ? res.content : ' '
            };
          }
        }
      }

      if (icon.startsWith('M') === true) {
        var _icon$split = icon.split('|'),
            _icon$split2 = _slicedToArray(_icon$split, 2),
            def = _icon$split2[0],
            viewBox = _icon$split2[1];

        return {
          svg: true,
          cls: this.classes,
          nodes: def.split('&&').map(function (path) {
            var _path$split = path.split('@@'),
                _path$split2 = _slicedToArray(_path$split, 3),
                d = _path$split2[0],
                style = _path$split2[1],
                transform = _path$split2[2];

            return _this.$createElement('path', {
              attrs: {
                d: d,
                transform: transform
              },
              style: style
            });
          }),
          viewBox: viewBox !== void 0 ? viewBox : '0 0 24 24'
        };
      }

      if (icon.startsWith('img:') === true) {
        return {
          img: true,
          cls: this.classes,
          src: icon.substring(4)
        };
      }

      if (icon.startsWith('svguse:') === true) {
        var _icon$split3 = icon.split('|'),
            _icon$split4 = _slicedToArray(_icon$split3, 2),
            _def = _icon$split4[0],
            _viewBox = _icon$split4[1];

        return {
          svguse: true,
          cls: this.classes,
          src: _def.substring(7),
          viewBox: _viewBox !== void 0 ? _viewBox : '0 0 24 24'
        };
      }

      var content = ' ';

      if (/^[l|f]a[s|r|l|b|d]{0,1} /.test(icon) || icon.startsWith('icon-') === true) {
        cls = icon;
      } else if (icon.startsWith('bt-') === true) {
        cls = "bt ".concat(icon);
      } else if (icon.startsWith('eva-') === true) {
        cls = "eva ".concat(icon);
      } else if (/^ion-(md|ios|logo)/.test(icon) === true) {
        cls = "ionicons ".concat(icon);
      } else if (icon.startsWith('ion-') === true) {
        cls = "ionicons ion-".concat(this.$q.platform.is.ios === true ? 'ios' : 'md').concat(icon.substr(3));
      } else if (icon.startsWith('mdi-') === true) {
        cls = "mdi ".concat(icon);
      } else if (icon.startsWith('iconfont ') === true) {
        cls = "".concat(icon);
      } else if (icon.startsWith('ti-') === true) {
        cls = "themify-icon ".concat(icon);
      } else {
        cls = 'material-icons';

        if (icon.startsWith('o_') === true) {
          icon = icon.substring(2);
          cls += '-outlined';
        } else if (icon.startsWith('r_') === true) {
          icon = icon.substring(2);
          cls += '-round';
        } else if (icon.startsWith('s_') === true) {
          icon = icon.substring(2);
          cls += '-sharp';
        }

        content = icon;
      }

      return {
        cls: cls + ' ' + this.classes,
        content: content
      };
    }
  },
  render: function render(h) {
    var data = {
      class: this.type.cls,
      style: this.sizeStyle,
      on: _objectSpread({}, this.qListeners),
      attrs: {
        'aria-hidden': 'true',
        role: 'presentation'
      }
    };

    if (this.type.none === true) {
      return h(this.tag, data, slot(this, 'default'));
    }

    if (this.type.img === true) {
      data.attrs.src = this.type.src;
      return h('img', data);
    }

    if (this.type.svg === true) {
      data.attrs.focusable = 'false';
      /* needed for IE11 */

      data.attrs.viewBox = this.type.viewBox;
      return h('svg', data, mergeSlot(this.type.nodes, this, 'default'));
    }

    if (this.type.svguse === true) {
      data.attrs.focusable = 'false';
      /* needed for IE11 */

      data.attrs.viewBox = this.type.viewBox;
      return h('svg', data, [h('use', {
        attrs: {
          'xlink:href': this.type.src
        }
      }), mergeSlot(this.type.nodes, this, 'default')]);
    }

    return h(this.tag, data, mergeSlot([this.type.content], this, 'default'));
  }
});